import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { chartPropTypes, namespace } from './model';
import { BarsContainer } from './components/bar/bars-container';
import { Flag } from './components/flag/flag';
import { LimitsContainer } from './components/line/limits-container';
import { Line } from './components/line/line';
import { calculateTooltipPosition } from './helpers/calculate-tooltip-position';
import { getBarsHeight } from './helpers/get-bars-height';
import { calculateLimitPosition } from './helpers/calculate-limit-position';

const defaultTooltip = {};

const Chart = ({
  pricesDistribution = null,
  barsHoverInfo = null,
  lowerBand = '',
  middleBand = '',
  upperBand = '',
  tooltip = defaultTooltip,
  tooltipFipe = null,
  padding = 48,
}) => {
  const { percentile_position: percentilePosition, data: tooltipValue, ...tooltipRest } = tooltip;
  const [lowerLimitSize, setLowerLimitSize] = useState({ width: 0, visible: false });
  const [upperLimitSize, setUpperLimitSize] = useState({ width: 0, visible: false });
  const [tooltipPosition, setTooltipPosition] = useState({ position: 0, valuePosition: 0, visible: false });
  const [tooltipFipePosition, setTooltipFipePosition] = useState({ position: 0, valuePosition: 0, visible: false });

  useEffect(() => {
    calculateLimitPosition(setLowerLimitSize, `${namespace}__lower`);
    calculateLimitPosition(setUpperLimitSize, `${namespace}__upper`);
    calculateTooltipPosition(setTooltipPosition, percentilePosition, `${namespace}__tooltip-value`, padding);
    if (tooltipFipe) {
      calculateTooltipPosition(
        setTooltipFipePosition,
        tooltipFipe.percentile_position,
        `${namespace}__tooltip-fipe-value`,
        padding,
      );
    }
  }, [percentilePosition, padding, tooltipFipe]);

  const barsHeight = pricesDistribution.map(value => getBarsHeight(value));

  const graphSize = tooltipRest.pole_size ? tooltipRest.pole_size.toLowerCase() : 'default';

  return (
    <div className={namespace}>
      <div className={classnames(`${namespace}__graph`, `${namespace}__graph-size--${graphSize}`)}>
        <BarsContainer
          barsContainerNamespace={namespace}
          barsHeight={barsHeight}
          padding={padding}
          barsHoverInfo={barsHoverInfo}
        />
        <Flag
          tooltipNamespace={classnames(`${namespace}__tooltip`, {
            [`${namespace}--visible`]: tooltipPosition.visible,
            [`${namespace}--alone`]: !tooltipFipe,
          })}
          valueClassName={`${namespace}__tooltip-value`}
          lineClassName={`${namespace}__tooltip-line`}
          tooltipPosition={tooltipPosition}
          tooltipValue={tooltipValue}
          poleSize={graphSize}
          {...tooltipRest}
        />
        {tooltipFipe && (
          <Flag
            tooltipNamespace={classnames(`${namespace}__tooltip`, `${namespace}__tooltip-fipe`, {
              [`${namespace}--visible`]: tooltipFipePosition.visible,
            })}
            valueClassName={`${namespace}__tooltip-value ${namespace}__tooltip-fipe-value`}
            lineClassName={`${namespace}__tooltip-line ${namespace}__tooltip-fipe-line`}
            tooltipPosition={tooltipFipePosition}
            tooltipValue={tooltipFipe.data}
          />
        )}
      </div>
      <Line className={`${namespace}__chart-line`} />
      <LimitsContainer
        limitsNamespace={namespace}
        lowerBand={lowerBand}
        middleBand={middleBand}
        upperBand={upperBand}
        upperLimitSize={upperLimitSize}
        lowerLimitSize={lowerLimitSize}
      />
    </div>
  );
};

Chart.propTypes = chartPropTypes;

export default Chart;
